import { InnosErrorBoundary } from '@inno-tools/container-bridge'
import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'

const EmployeesNotificationsConsentModalContent = () => {
  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_EMPLOYEES_APP_DEV_PATH,
    'hr',
    './EmployeesNotificationsConsentModal',
    'employeesApp'
  )

  // @ts-expect-error: dynamic import
  const { EmployeesNotificationsConsentModal } =
    isLoaded && !isError && !missingRemoteUrl && module
      ? module
      : {
          EmployeesNotificationsConsentModal: () => <></>
        }
  return <EmployeesNotificationsConsentModal />
}

export const EmployeesNotificationsConsentModal = () => (
  <InnosErrorBoundary>
    <EmployeesNotificationsConsentModalContent />
  </InnosErrorBoundary>
)
